import client from 'gql/client';
import {
  refreshDealerSettingsQuery,
  refreshInstallationDealerSettingsQuery,
} from 'gql/dealerSettings/dealerSettings.gql';

type dealerSettingValues = {
  externalCustomerPortalUrl: string;
  ecommerceUrl: string;
  ecommerceBatteryUrl: string;
  ecommerceSmsUrl: string;
};

export const getInstallationDealerSettings = async (giid: string): Promise<dealerSettingValues | undefined> => {
  try {
    const result = await client.query<{}>({
      query: refreshInstallationDealerSettingsQuery,
      variables: { giid },
    });
    const {
      data: {
        installation: { dealerSettings },
      },
    } = result;

    return dealerSettings;
  } catch (e) {
    if (!(e as any).networkError) {
      throw e;
    }
  }
};

export const getLocaleDealerSettings = async (locale: string): Promise<dealerSettingValues | undefined> => {
  try {
    const result = await client.query<{}>({
      query: refreshDealerSettingsQuery,
      variables: { locale },
    });
    const {
      data: { dealerSettings },
    } = result;
    return dealerSettings;
  } catch (e) {
    if (!(e as any).networkError) {
      throw e;
    }
  }
};
